module.exports = __webpack_public_path__ + "assets/img/9.8cec50f0.png";